export const CAN_VIEW_BOARD = 'CAN_VIEW_BOARD' as const;
export const CAN_BULK_CHANGE_ISSUES = 'CAN_BULK_CHANGE_ISSUES' as const;
export const CAN_EDIT_BOARD_CONFIG = 'CAN_EDIT_BOARD_CONFIG' as const;
export const CAN_MANAGE_SPRINTS = 'CAN_MANAGE_SPRINTS' as const;
export const CAN_CREATE_ISSUES = 'CAN_CREATE_ISSUES' as const;
export const CAN_EDIT_ISSUES = 'CAN_EDIT_ISSUES' as const;
export const CAN_DELETE_ISSUES = 'CAN_DELETE_ISSUES' as const;
export const CAN_ASSIGN_ISSUES = 'CAN_ASSIGN_ISSUES' as const;
export const CAN_TRANSITION_ISSUES = 'CAN_TRANSITION_ISSUES' as const;
export const CAN_ARCHIVE_ISSUE = 'CAN_ARCHIVE_ISSUE' as const;
